import {Collapse} from 'bootstrap';

export default function OfferFilter() {
    const collapseFilter = new Collapse(' #collapseFilter', {
        toggle: false
    })

    function closeFilterWhenWidth(width) {
        if (width >= 992) {
            collapseFilter.show();
        } else {
            collapseFilter.hide();
        }
    }

    window.addEventListener('resize', e => {
        closeFilterWhenWidth(window.innerWidth);
    }, true);
    closeFilterWhenWidth(window.innerWidth);

    /*
    const filterWrapper = document.getElementById('offer-filter');
    if(!filterWrapper) return;

    const offersList = document.querySelectorAll('.offer-card');
    const providers = new Set();
    const categories = new Set();
    let inputValues = {};

    getData();
    renderFilterEl('offer-filter_categories', categories, 'category');
    renderFilterEl('offer-filter_providers', providers, 'provider');
    setChangeEvent();


    function getData() {
        const obj = [];
        Object.values(offersList).forEach((el, idx) => {
            providers.add(el.dataset.provider);
            categories.add(el.dataset.category);
        });
    }

    function renderFilterEl(wrapperId, data, filterName) {
        const el = document.getElementById(wrapperId);

        let html = '';
        data = Array.from(data); // Set to Array
        data.forEach(function (val, idx) {
            html += '<div class="form-check form-check-inline">' +
                '<input class="form-check-input" type="checkbox" id="offer-filter_' + filterName + '-' + idx + '"' +
                'name="' + filterName + '" value="' + val + '">' +
                '<label class="form-check-label" for="offer-filter_' + filterName + '-' + idx + '">' + val + '</label>' +
                '</div>';
        });
        el.innerHTML += html;
    }

    function setChangeEvent() {
        const filterInputs = filterWrapper.querySelectorAll('input');
        filterInputs.forEach((input) => {
            input.addEventListener('change', (event) => {
                getInputValues();
            });
        });
    }

    function getInputValues() {
        const filterInputs = filterWrapper.querySelectorAll('input:checked');
        inputValues = {};
        filterInputs.forEach((input) => {
            if (!inputValues[input.name])
                inputValues[input.name] = [];

            inputValues[input.name].push(input.value);
        });
        applyFilter();
    }

    function applyFilter() {
        let count = 0;
        Object.values(offersList).forEach((el, idx) => {
            let show = true;

            Object.keys(inputValues).forEach((filter) => {
                let filerVals = inputValues[filter]
                let elVal = el.dataset[filter];
                if (!filerVals.includes(elVal))
                    show = false;
            });

            if (show) {
                count++;
                el.style.display = 'block';
            } else {
                el.style.display = 'none';
            }
        });
        const counters = document.getElementsByClassName('offer-filter_items-count');
        for (let counter of counters) {
            counter.innerHTML = count;
        }
    }
*/
}


